import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateExerciseList = {
  exerciseList: { data: null, loading: false, error: null },
};

export const exerciseList = createAsyncThunk('user/exerciseList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/exercise/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerExerciseList = {
  [exerciseList.pending]: (state) => {
    state.exerciseList.loading = true;
  },
  [exerciseList.fulfilled]: (state, action) => {
    state.exerciseList.loading = false;
    state.exerciseList.data = action.payload;
    state.exerciseList.error = null;
  },
  [exerciseList.rejected]: (state, action) => {
    state.exerciseList.data = null;
    state.exerciseList.loading = false;
    state.exerciseList.error = action.payload;
  },
};
